import { Cell, Grid, Link, Text, VFlow } from 'bold-ui'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { PageHeader } from 'components/PageHeader'
import React from 'react'

export const LinksUteisView = () => {
  return (
    <PageContent type='filled'>
      <Breadcrumb title='Links úteis' />
      <VFlow vSpacing={2}>
        <PageHeader title='Links úteis' />
        <Grid>
          <Cell size={9}>
            <VFlow vSpacing={1}>
              <div>
                <Text component='p' fontWeight='bold'>
                  Portal Saúde Baseada em Evidências
                </Text>
                <Link target='_blank' href='http://www.psbe.ufrn.br'>
                  http://psbe.ufrn.br
                </Link>
              </div>
              <div>
                <Text component='p' fontWeight='bold'>
                  Ministério da Saúde
                </Text>
                <Link target='_blank' href='http://portalms.saude.gov.br'>
                  http://portalms.saude.gov.br
                </Link>
              </div>
              <div>
                <Text component='p' fontWeight='bold'>
                  Secretaria de Atenção Primária à Saúde (SAPS)
                </Text>
                <Link target='_blank' href='http://aps.saude.gov.br'>
                  http://aps.saude.gov.br
                </Link>
              </div>
              <div>
                <Text component='p' fontWeight='bold'>
                  Estratégia e-SUS Atenção Primária
                </Text>
                <Link target='_blank' href='http://aps.saude.gov.br/ape/esus'>
                  http://aps.saude.gov.br/ape/esus
                </Link>
              </div>
              <div>
                <Text component='p' fontWeight='bold'>
                  Sugestões para o PEC e-SUS APS
                </Text>
                <Link target='_blank' href='http://sisaps.saude.gov.br/pesquisaesusab/'>
                  http://sisaps.saude.gov.br/pesquisaesusab/
                </Link>
              </div>
              <div>
                <Text component='p' fontWeight='bold'>
                  Programa de Melhoria do Acesso e Qualidade na Atenção Básica
                </Text>
                <Link target='_blank' href='http://aps.saude.gov.br/ape/pmaq'>
                  http://aps.saude.gov.br/ape/pmaq
                </Link>
              </div>
            </VFlow>
          </Cell>
        </Grid>
      </VFlow>
    </PageContent>
  )
}
